import { ENV_PROD } from 'environments/i-prod';
import { IEnvConfig } from 'interfaces/i-env-config';
import { LanguageCode } from 'lib_ts/enums/translation';

export const ENV_PROD_JP: IEnvConfig = {
  ...ENV_PROD,

  // todo: add japanese to this list to expose the language selector
  languages: [LanguageCode.English],

  liveboard_url: 'https://jp.live.trajektsports.app',

  region_redirect: true,
  self_url: 'https://jp.trajektsports.app',
  server_url: 'https://jp.trajektsports.app/node',
  ws_url: 'https://jp.trajektsports.app/users',
  ws_path: '/socket.io/',
};
